const calculateSpeedAndPace = (data) => {
  if (!data || typeof data !== 'object') {
    console.error('❌ [calculateSpeedAndPace] El objeto de datos es inválido o undefined:', data);
    return fallbackResult();
  }

  const session = Array.isArray(data.sessions)
    ? data.sessions[0]
    : data.sessions || data.session;

  const activity = data.activity || {};

  if (!session || !activity) {
    console.warn('⚠️ [calculateSpeedAndPace] Falta session o activity:', { session, activity });
    return fallbackResult();
  }

	const totalTimeInSeconds = session.total_timer_time || session.totalTimerTime || 0;
	const totalTimeInHours = totalTimeInSeconds / 3600;

	const totalDistanceInMeters =
	  session.total_distance || session.totalDistance || 0;
	const totalDistanceInKm = totalDistanceInMeters / 1000;


  if (totalTimeInHours === 0 || totalDistanceInKm === 0) {
    console.warn('⚠️ [calculateSpeedAndPace] Tiempo o distancia inválidos', {
      totalTimeInSeconds,
      totalDistanceInMeters
    });
    return fallbackResult();
  }

  const avgSpeed = (totalDistanceInKm / totalTimeInHours).toFixed(2); // km/h

  let maxSpeedRaw = session.enhanced_max_speed || session.enhancedMaxSpeed;
  if (!maxSpeedRaw && Array.isArray(data.laps)) {
    maxSpeedRaw = Math.max(
      ...data.laps.map((lap) => {
        const timeH = (lap.total_elapsed_time || 0) / 3600;
        const distKm = (lap.total_distance || 0) / 1000;
        return timeH > 0 ? distKm / timeH : 0;
      })
    ) / 3.6;
  }

  const maxSpeed = maxSpeedRaw ? (maxSpeedRaw * 3.6).toFixed(2) : '0.00';

  const avgPace = (totalTimeInHours * 60) / totalDistanceInKm;
  const maxPace = (1 / (maxSpeedRaw * 3.6 || 1)) * 60;

//  console.log('✅ [calculateSpeedAndPace] Velocidades y ritmos calculados:', {
//    avgSpeed,
//    maxSpeed,
//    avgPace: formatPace(avgPace),
//    maxPace: formatPace(maxPace)
//  });

  return {
    avgSpeed,
    maxSpeed,
    avgPace: formatPace(avgPace),
    maxPace: formatPace(maxPace)
  };
};

const fallbackResult = () => ({
  avgSpeed: '0.00',
  maxSpeed: '0.00',
  avgPace: '0:00',
  maxPace: '0:00'
});

const formatPace = (pace) => {
  if (!isFinite(pace)) return '0:00';
  const minutes = Math.floor(pace);
  const seconds = Math.round((pace - minutes) * 60);
  return `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
};

export const mpsToKmph = (mps) => {
  return mps ? (mps * 3.6).toFixed(2) : null;
};


export default calculateSpeedAndPace;
 
